import React from 'react';
import { arrayOf } from 'prop-types';
import styled from 'styled-components/macro';

import { locationType, pageLinkType } from 'types';
import NavItem from 'components/NavItem';

const NavPrimitive = styled.nav`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Nav = ({ location, items }) => (
  <NavPrimitive>
    {items.map((item) => (
      <NavItem
        key={item.id}
        item={item}
        location={location}
        exact={item.exact}
        isActive={item.isActive}
      />
    ))}
  </NavPrimitive>
);

Nav.propTypes = {
  items: arrayOf(pageLinkType).isRequired,
  location: locationType.isRequired
};

export default Nav;
